declare const componentHandler: any;
import './registerServiceWorker';
import config from './amplify';

import './polyfill.js';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import Auth from '@aws-amplify/auth';
import API from '@aws-amplify/api';

Auth.configure(config);
API.configure(config);

Vue.config.productionTip = false;

let pathHistory: any[] = [];
if (window.location.pathname === '/index.html' && window.location.search === '?source=homescreen') {
  pathHistory = JSON.parse(localStorage.getItem('rabbit-history')! || '[]');
  for (const h of pathHistory) {
    window.history.pushState(null, '', h);
  }
}
router.beforeEach((to: any, from: any, next: () => void) => {
  store.commit('updateTitle', to.name || '');
  next();
});

store.state.user = JSON.parse(localStorage.getItem('rabbit-user') || 'null');
store.state.organization = JSON.parse(localStorage.getItem('rabbit-organization') || '[]');
store.state.group = JSON.parse(localStorage.getItem('rabbit-group') || '{}');
store.state.message = JSON.parse(localStorage.getItem('rabbit-message') || '{}');
store.state.showOrg = JSON.parse(localStorage.getItem('rabbit-showOrg') || '""');

router.afterEach(async (to: any, from: any) => {
  setTimeout(() => componentHandler.upgradeDom(), 200);
  if (to.path === '/' || to.path === '/index.html') {
    pathHistory = [];
  } else {
    pathHistory.push(to.path);
    localStorage.setItem('rabbit-history', JSON.stringify(pathHistory));
  }
});

window.addEventListener('popstate', (event: any) => {
  pathHistory.pop();
  pathHistory.pop();
  localStorage.setItem('rabbit-history', JSON.stringify(pathHistory));
});

Vue.prototype.$apiPath = config.apiPath;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
